const ContactInfo = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-black mb-4">Get In Touch</h2>
          <p className="text-lg text-gray-600">
            Ready to start your project? Contact us today for a free consultation
          </p>
        </div>

        <div className="bg-zinc-900 rounded-3xl p-12 text-white">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-black text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2">Phone</h3>
                  <a
                    href="tel:8286341304"
                    className="text-yellow-500 text-xl font-semibold hover:text-yellow-400 transition-colors cursor-pointer"
                  >
                    (828) 634-1304
                  </a>
                  <p className="text-gray-400 text-sm mt-1">Available 24/7</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-fill text-black text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2">Email</h3>
                  <a
                    href="mailto:nicholas.list19@gmail.com"
                    className="text-yellow-500 hover:text-yellow-400 transition-colors cursor-pointer break-all"
                  >
                    nicholas.list19@gmail.com
                  </a>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-fill text-black text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2">Address</h3>
                  <p className="text-gray-300">
                    Otto, NC
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-facebook-fill text-black text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2">Social Media</h3>
                  <a
                    href="https://www.facebook.com/p/LG-Concrete-Pumping-Stone-61572378585686"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-yellow-500 hover:text-yellow-400 transition-colors cursor-pointer"
                  >
                    Follow us on Facebook
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;